import React from 'react';

const NoData: React.FC<{ message?: string }> = ({ message = 'No Data' }) => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <label className="text-2xl text-grey5 font-semibold">{message}</label>
    </div>
  );
};

export default NoData;
